<template>
  <div class="max-w-lg mx-auto py-16 px-4 text-center">
    <div class="flex justify-center mb-6">
      <div class="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
        <XIcon class="w-8 h-8 text-red-600" />
      </div>
    </div>

    <h2 class="text-2xl font-bold mb-4">Votre résiliation est enregistrée</h2>

    <p class="text-gray-600 mb-6">
      Votre contrat sera résilié conformément à votre demande. Votre couverture prendra fin à la date d'effet de la
      résiliation.
    </p>

    <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-8">
      <p class="text-yellow-800 text-sm">Un email de confirmation de résiliation vous a été envoyé.</p>
      <p class="text-yellow-800 text-sm mt-2">
        Vous avez la possibilité de revenir sur votre décision dans un délai de 15 jours en nous contactant à
        <a href="mailto:contact@estaly.co" class="font-medium underline">contact@estaly.co</a>
        .
      </p>
    </div>

    <PrimaryButton @click="$emit('close')">RETOUR À MON ESPACE</PrimaryButton>
  </div>
</template>

<script>
import { PrimaryButton } from "@estaly/ui";
import { XIcon } from "@heroicons/vue/solid";

export default {
  components: { PrimaryButton, XIcon },

  emits: ["close"],
};
</script>
